<template>
  <div :class="['tva-slider']">
    <div class="tva-slider-container" ref="slider">
      <slot></slot>
    </div>
    <div class="tva-arrows" v-if="arrows">
      <button
        v-for="(arrowDirection, i) of ['sx', 'dx']"
        :key="arrowDirection"
        :class="['tva-arrow', 'tva-arrow-' + arrowDirection]"
        :aria-label="arrowAriaLabels[i]"
        @click="manageClick(arrowDirection)"
      >
        <svg class="tva-arrow-icon" viewBox="0 0 48 48">
          <path
            d="M9.37263 8.57677C9.37185 9.25108 9.09135 9.89484 8.59803 10.3545L1.67739 16.9281C1.50674 17.0894 1.23764 17.0818 1.07634 16.9112C0.915033 16.7405 0.922614 16.4714 1.09327 16.3101L8.0139 9.75772C8.34243 9.45313 8.52821 9.02476 8.52607 8.57677C8.52038 8.13148 8.33034 7.70849 8.0012 7.40851L0.90279 0.843433C0.750756 0.680965 0.750468 0.428524 0.902131 0.265711C1.05379 0.102896 1.30562 0.0853004 1.47845 0.225445L8.57687 6.79899C9.07801 7.25499 9.36639 7.89924 9.37263 8.57677Z"
            transform="translate(20,16)"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import Flickity from "flickity-imagesloaded";

export default {
  props: {
    config: { type: Object, default: null },
    currentIndex: Number,
    arrows: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isFlickity: false,
      elementsCount: [],
      index: 0,
      fade: false,
      arrowAriaLabels: ["button previous", "button next"],
      options: {
        draggable: ">1",
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: true,
        imagesLoaded: true,
        lazyLoad: true,
        adaptiveHeight: true,
        fade: false,
        wrapAround: true,
      },
    };
  },
  computed: {},
  created() {
    this.options.initialIndex = this.currentIndex;
    this.setProps(this.config);
  },
  watch: {
    config(config) {
      this.setProps(config);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.elementsCount = new Array(this.$refs.slider.childElementCount).fill(
        0
      );
      this.createFlickity();

      window.addEventListener("resize", () => {
        this.createFlickity();
      });
    });
  },
  methods: {
    setProps(config) {
      if (config) {
        for (const [key, value] of Object.entries(config)) {
          this[key] = value;
        }
      }
    },
    createFlickity() {
      var elem = this.$refs.slider;

      if (elem && !this.isFlickity) {
        this.flkty = new Flickity(elem, this.options);

        this.flkty.on("change", (index) => {
          this.index = index;
          this.$emit("change", index);
        });

        this.isFlickity = true;
      } else if (!elem && this.isFlickity) {
        this.flkty.destroy();
        this.flkty = null;
        this.isFlickity = false;
      }
    },
    manageClick(arrowDirection) {
      arrowDirection === "sx" ? this.goPrevious() : this.goNext();
    },
    goTo(index) {
      this.flkty.select(index);
    },
    goPrevious() {
      this.flkty.previous();
    },
    goNext() {
      this.flkty.next();
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  height: 100%;
}

.tva-slider-container {
  width: 100%;
}
.tva-dots,
.tva-arrows {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 100%;
  transform: translateY(-50%);
  .mobile & {
    top: 100%;
  }
}
.tva-slider {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .tva-dots {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    z-index: 1;

    .tva-dot {
      border-radius: 100%;
      padding: 0;
      cursor: pointer;
      &:hover {
      }
      &:last-of-type {
        margin-right: 0 !important;
      }
    }
  }
  .tva-arrows {
    z-index: 1;
    height: auto;
    display: flex;
    justify-content: space-between;
    pointer-events: none;

    .tva-arrow {
      pointer-events: all;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: none;
      cursor: pointer;
      background: rgba(51, 51, 51, 0.7);
      backdrop-filter: blur(5px);
      width: 48px;
      height: 48px;
      &.tva-arrow-sx {
        margin-left: 20px;
        transform: rotate(180deg);
      }
      &.tva-arrow-dx {
        margin-right: 20px;
      }
      .tva-arrow-icon {
        width: 100%;
        display: block;
        fill: $scala-grigi-gray-5;
      }
      &:hover {
        .tva-arrow-icon {
          fill: $primary-yellow;
        }
      }
    }
  }
}
</style>

<style lang="scss">
/*! Flickity v2.2.0
https://flickity.metafizzy.co
---------------------------------------------- */

.flickity-enabled {
  position: relative;
}

.flickity-enabled:focus {
  outline: none;
}

.flickity-viewport {
  overflow: hidden;
  position: relative;
  height: 100%;
}

.flickity-slider {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* draggable */

.flickity-enabled.is-draggable {
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.flickity-enabled.is-draggable .flickity-viewport {
  cursor: move;
  cursor: -webkit-grab;
  cursor: grab;
}

.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
</style>
